import { writable } from 'svelte/store';
export const currentUser = writable(null);
export const clientId = writable(null);
export const websiteClientId = writable(null);

export const getWebsiteClientId = (website) => {
	if (website && website !== 'abc-school-supplies') {
		const dashPosition = website.lastIndexOf('-');
		if (dashPosition >= 0) {
			return website.slice(dashPosition + 1);
		}
	}

	return false;
};

export const onCopyClick = (text) => {
	let temp = document.createElement('textarea');
	temp.value = text;
	document.body.appendChild(temp);
	temp.select();
	document.execCommand('copy');
	document.body.removeChild(temp);
};

export const formatNumberToTwoDecimals = (number) => {
	if (typeof number !== 'number') return number;

	return (Math.ceil(number * 100) / 100).toFixed(2);
};
